import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IDocument } from '../Document.ts';
import { DocumentApi } from '../../../apis/Documents/DocumentApi.ts';

export function usePostDocumentMutations() {
    return useMutation<IDocument, AppMedError, IDocument>({
        mutationKey: [QueryKeys.documents],
        mutationFn: async (variables: IDocument) => {
            const docId = await DocumentApi.postDocument(variables);
            return { ...variables, id: Number(docId) };
        },
        // Do not invalidate the documents list here. The caller (DocumentForm)
        // performs the S3 upload after this mutation resolves and then calls
        // refetchDocuments(). Invalidating here would trigger an immediate
        // GET /Patients/:id/Documents *before* the S3 upload completes; the
        // backend's GetPatientDocuments soft-deletes any document that has no
        // file in S3 yet, so the just-created row would come back IsDeleted=1.
    });
}
